import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

@Injectable({
  providedIn: 'root'
})
export class FingerprintPortalService {

  constructor(
    private httpservice: HttpService) { }
  fetchFingerPrintData(searchParams: any) {
    return this.httpservice.post(API_ENDPOINTS.fetchFingerPrintDetails, searchParams);
  }
  fingerPrintSubmissionOptions(){
    return this.httpservice.get(API_ENDPOINTS.FPRINT_SUB_METHOD);
  }
  updateFingerPrintRecord(submissionData:any){
    return this.httpservice.patch(API_ENDPOINTS.updateFingerPrintRecord, submissionData);
  }
  FingerPrintPortalnotifiction(data:any){
    return this.httpservice.post(API_ENDPOINTS.notifiction,data);
  }
}
